var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "notification-item",
      class: _vm.dynamicClasses,
      on: {
        mouseover: function($event) {
          _vm.notificationItemHovered = true
        },
        mouseleave: function($event) {
          _vm.notificationItemHovered = false
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "black notification-message-container cpointer pr-3 py-2 pl-2",
          on: { click: _vm.onClickBanner }
        },
        [
          _vm.isEmailNotification
            ? [
                _c("NotificationEmail", {
                  attrs: { type: "item", notification: _vm.item.notif }
                })
              ]
            : _vm.isReminderActivity
            ? _c("NotificationReminderActivity", {
                attrs: {
                  notification: _vm.item.notif,
                  context: _vm.NOTIFICATION_CONTEXT.NOTIFICATION_CENTER
                }
              })
            : _c(
                "div",
                { staticClass: "notification-content-container" },
                [
                  _vm.showLogo
                    ? _c("CompassLogo", {
                        attrs: { type: "icon", theme: "light", width: 32 }
                      })
                    : _c("CompassAvatar", {
                        attrs: {
                          size: "small",
                          initials: _vm.getInitialsAvatar,
                          src: _vm.getSourceAvatar
                        }
                      }),
                  _vm._v(" "),
                  _vm.item.isSystem
                    ? _c(
                        "p",
                        [
                          _vm.isConsentNotification
                            ? [
                                _c(
                                  "CompassTooltip",
                                  {
                                    attrs: {
                                      contentClass: "notification-item-tooltip"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "content",
                                          fn: function() {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "semibold" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.item.linkedObject.name
                                                    ) + " "
                                                  )
                                                ]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      4251855486
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "notification-item-name" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.item.linkedObject.name) +
                                            " :\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.targetedStaffFullName
                                  ? _c(
                                      "CompassTooltip",
                                      {
                                        attrs: {
                                          contentClass:
                                            "notification-item-tooltip"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "content",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "span",
                                                    { staticClass: "semibold" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.targetedStaffFullName
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          2080020209
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "notification-item-name"
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.targetedStaffFullName
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(" " + _vm._s(_vm.item.message))
                                ])
                              ]
                            : [
                                _c(
                                  "CompassTooltip",
                                  {
                                    attrs: {
                                      contentClass: "notification-item-tooltip"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "content",
                                          fn: function() {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "semibold" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.item.linkedObject.name
                                                    ) + " "
                                                  )
                                                ]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      4251855486
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "notification-item-name" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.item.linkedObject.name) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(": " + _vm._s(_vm.item.message))
                                ])
                              ]
                        ],
                        2
                      )
                    : _c("p", [
                        _c("span", { staticClass: "semibold" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$filters.capitalize(
                                  _vm.item.sender.firstname
                                )
                              ) +
                              "\n                    " +
                              _vm._s(
                                _vm.$filters.capitalize(
                                  _vm.item.sender.lastname
                                )
                              ) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.item.message) +
                              " " +
                              _vm._s(_vm.getTargetLabel())
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "semibold" }, [
                          _vm._v(_vm._s(_vm.item.linkedObject.name))
                        ])
                      ])
                ],
                1
              ),
          _vm._v(" "),
          _c("div", { staticClass: "notification-actions-container" }, [
            _c(
              "div",
              { staticClass: "flex-right" },
              [
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "bottom-end",
                      trigger: "manual",
                      popperClass:
                        "gray-100 popover-actions-notif p-0 mt-1 b-0",
                      visibleArrow: false,
                      appendToBody: false
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "reference",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "notification-actions icon-container flex-level hover-primary-05-bkg jc-center",
                                class: _vm.visibilityAction,
                                attrs: { id: "menu-notif" },
                                on: {
                                  blur: function($event) {
                                    if (
                                      $event.target !== $event.currentTarget
                                    ) {
                                      return null
                                    }
                                    $event.stopPropagation()
                                    _vm.displayActions = false
                                  },
                                  mouseover: function($event) {
                                    _vm.notificationMenuHovered = true
                                  },
                                  mouseleave: function($event) {
                                    _vm.notificationMenuHovered = false
                                  },
                                  click: function($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    _vm.displayActions = !_vm.displayActions
                                  }
                                }
                              },
                              [
                                _c("icon", {
                                  staticClass: "fs-4",
                                  attrs: { icon: "icon-burger" }
                                })
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.displayActions,
                      callback: function($$v) {
                        _vm.displayActions = $$v
                      },
                      expression: "displayActions"
                    }
                  },
                  [
                    _c(
                      "ul",
                      {
                        staticClass: "m-0 p-2",
                        on: {
                          mouseleave: _vm.popoverLeaved,
                          mouseover: function($event) {
                            _vm.isPopoverHovered = true
                          }
                        }
                      },
                      [
                        _c(
                          "li",
                          {
                            staticClass:
                              "p-2 flex-level hover-primary-05-bkg br cpointer",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.deleteNotification($event)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "icon icon-trash-fillout mr-2"
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$l10n.__("Supprimer cette notification")
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.item.read !== null,
                                expression: "item.read !== null"
                              }
                            ],
                            staticClass:
                              "p-2 flex-level hover-primary-05-bkg br cpointer",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.markAsUnRead($event)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "icon el-icon-check bold mr-2"
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$l10n.__("Marquer comme non lu"))
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-right notification-chip-container" },
              [
                _c("notification-chip", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.item.read === null,
                      expression: "item.read === null"
                    }
                  ],
                  on: { clicked: _vm.markAsRead }
                })
              ],
              1
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }